module.exports = __webpack_public_path__ + "static/media/hero-3.2dea225e.png";